export default __webpack_public_path__ + "static/media/message.d6efde10.svg";